import type { InjectionKey } from "vue";

/**
 * Hook haptic fourni par l'app ionic (`provide` à la racine) et consommé par les composants shared
 * qui doivent vibrer sur ionic sans importer `@capacitor/haptics` (interdit dans shared/).
 * Défaut = no-op → web/admin ne fournissent pas le hook, donc zéro vibration et zéro haptics dans shared.
 */
export const hapticInjectionKey: InjectionKey<() => void | Promise<void>> = Symbol("cfl-haptic");
